<div style="width: 600px;">
  <div class="alert alert-info">
    <div><strong>{{_(KEYS.TWO_FA.TITLE)}}</strong> {{_(KEYS.TWO_FA.INFO)}}</div>
    <div class="mt-1"><small>{{_(KEYS.TWO_FA.STEPS_HINT)}}</small></div>
  </div>

  <div class="mb-2">
    <span class="badge" [ngClass]="user?.mfaEnabled ? 'badge-success' : 'badge-secondary'">
      <i
        [class]="user?.mfaEnabled ? 'fa fa-check' : 'fa fa-times'"
        [ngStyle]="{'margin-right.px': 6}"></i>
      {{ user?.mfaEnabled ? _(KEYS.TWO_FA.STATUS_ENABLED) : _(KEYS.TWO_FA.STATUS_DISABLED) }}
    </span>
  </div>

  <hr>
  <div *ngIf="!user?.mfaEnabled && !mfaSetup" class="form-group">
    <button class="btn btn-success" (click)="initiateMfa()">{{_(KEYS.TWO_FA.BTN_SETUP)}}</button>
  </div>

  <div *ngIf="mfaSetup">
    <div class="mb-2">
      <small>{{mfaSetup.issuer}} - {{mfaSetup.username}}</small>
    </div>
    <div class="qr-wrap mb-2" style="display: flex; align-items: center; gap: 16px;">
      <qrcode [qrdata]="mfaSetup.otpauthUrl" [margin]="0" [width]="192" [errorCorrectionLevel]="'M'"></qrcode>
      <div>
        <div><strong>{{_(KEYS.TWO_FA.LABEL_SECRET)}}</strong>: <code>{{mfaSetup.secretBase32}}</code></div>
        <div><small>{{_(KEYS.TWO_FA.LABEL_DIGITS_PERIOD, {digits: mfaSetup.digits, period: mfaSetup.period})}}</small></div>
      </div>
    </div>

    <div class="form-inline">
      <input class="form-control mr-2" [placeholder]="_(KEYS.TWO_FA.PLACEHOLDER_OTP)" [(ngModel)]="mfaCode" name="mfaCode">
      <button class="btn btn-success" (click)="verifyMfa()">{{_(KEYS.TWO_FA.BTN_ENABLE)}}</button>
    </div>
  </div>

  <div class="mt-3" *ngIf="user?.mfaEnabled">
    <div class="form-inline">
      <input class="form-control mr-2" [placeholder]="_(KEYS.TWO_FA.PLACEHOLDER_OTP)" [(ngModel)]="mfaDisableCode" name="mfaDisableCode">
      <button class="btn btn-danger" (click)="disableMfaSelf()">{{_(KEYS.TWO_FA.BTN_DISABLE)}}</button>
    </div>
  </div>
</div>


